import clsx from 'clsx';
import React from 'react';

const Lozenge = ({ children, appearance = 'default', className }) => {
  return (
    <span
      className={clsx(
        'first-letter:uppercase inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80',
        {
          'text-gray-500 bg-gray-100': appearance === 'default',
          'text-white bg-green-100': appearance === 'success',
          'text-white from-chocolate-500 to-pink-500 bg-gradient-to-r': appearance === 'attention',
        },
        className,
      )}
    >
      {children}
    </span>
  );
};

export default Lozenge;
